export const TOGGLE_LOADING = 'staff/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'staff/TOGGLE_SUCCESS'
export const TOGGLE_ERROR = 'staff/TOGGLE_ERROR'
export const SET_STAFF_PROJECT = 'staff/SET_STAFF_PROJECT'
export const ADD_OPENED_CHILD_ID = 'staff/ADD_OPENED_CHILD_ID'
export const REMOVE_OPENED_CHILD_ID = 'staff/REMOVE_OPENED_CHILD_ID'
export const SET_STAFF_XML = 'staff/SET_STAFF_XML'

export const SET_STATUS = 'staff/SET_STATUS'

export const GET_POSITION_DEPT_TYPE = 'staff/GET_POSITION_DEPT_TYPE'
export const GET_POSITION_DEPT_TYPE_DONE = 'staff/GET_POSITION_DEPT_TYPE_DONE'
export const GET_POSITION_DEPT_TYPE_FAIL = 'staff/GET_POSITION_DEPT_TYPE_FAIL'

export const GET_STAFF_EXPERIENCE = 'staff/GET_STAFF_EXPERIENCE'
export const GET_STAFF_EXPERIENCE_DONE = 'staff/GET_STAFF_EXPERIENCE_DONE'
export const GET_STAFF_EXPERIENCE_FAIL = 'staff/GET_STAFF_EXPERIENCE_FAIL'

export const GET_STAFF_UNIT = 'staff/GET_STAFF_UNIT'
export const GET_STAFF_UNIT_DONE = 'staff/GET_STAFF_UNIT_DONE'
export const GET_STAFF_UNIT_FAIL = 'staff/GET_STAFF_UNIT_FAIL'

export const GET_STAFF_LEVEL = 'staff/GET_STAFF_LEVEL'
export const GET_STAFF_LEVEL_DONE = 'staff/GET_STAFF_LEVEL_DONE'
export const GET_STAFF_LEVEL_FAIL = 'staff/GET_STAFF_LEVEL_FAIL'
